import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Reason } from '@/types/reason'

export function createReason(body: Reason): Promise<AxiosResponse<Reason>> {
  return instance.post(`/reason`, body)
}
